// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";
import Dropdown from "stimulus-dropdown";
import Chart from "stimulus-chartjs";

import TurboModalController from "./turbo_modal_controller.js";
application.register("turbo-modal", TurboModalController);
application.register("dropdown", Dropdown);
application.register("chart", Chart);
